import { toast } from "react-toastify";

import { GetCouponResponseBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

export const fetchCoupon = async (
  code: string
): Promise<GetCouponResponseBodyType> => {
  try {
    const resp = await api.get<GetCouponResponseBodyType>(
      `/v2/stripe/coupons/${code}`
    );
    return resp.data;
  } catch (e) {
    toast.error("error validating code");
    return {
      coupon: null,
    };
  }
};

export const useFetchCoupon = () => {
  return useMutation<GetCouponResponseBodyType, Error, string>({
    mutationFn: async (code: string) => fetchCoupon(code),
    onSuccess: (data) => {
      if (data.coupon) {
        toast.success("Coupon validated!");
      } else {
        toast.error("Invalid Coupon");
      }
    },
  });
};
